/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Plan_Edit_Move_UpInputs */

const en_us2_plan_edit_move_up = /** @type {(inputs: Plan_Edit_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} up`)
};

const pt_br2_plan_edit_move_up = /** @type {(inputs: Plan_Edit_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover ${i?.name} para cima`)
};

const es_419_plan_edit_move_up = /** @type {(inputs: Plan_Edit_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Subir ${i?.name}`)
};

const pt_pt2_plan_edit_move_up = /** @type {(inputs: Plan_Edit_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mover ${i?.name} para cima`)
};

const fr_fr2_plan_edit_move_up = /** @type {(inputs: Plan_Edit_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Monter ${i?.name}`)
};

const de_de2_plan_edit_move_up = /** @type {(inputs: Plan_Edit_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nach oben verschieben`)
};

const it_it2_plan_edit_move_up = /** @type {(inputs: Plan_Edit_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sposta ${i?.name} in su`)
};

/**
* | output |
* | --- |
* | "Move {name} up" |
*
* @param {Plan_Edit_Move_UpInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_move_up = /** @type {((inputs: Plan_Edit_Move_UpInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Move_UpInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_move_up(inputs)
	if (locale === "es-419") return es_419_plan_edit_move_up(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_move_up(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_move_up(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_move_up(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_move_up(inputs)
	return en_us2_plan_edit_move_up(inputs)
});
export { plan_edit_move_up as "plan-edit.move_up" }